import type { FC } from "react";
import * as AD from "../ui/alert-dialog";
import * as DG from "../ui/dialog";
import * as DM from "../ui/dropdown-menu";

// shadcn components are plain JSX; loosen their inferred prop types for TSX use.
type Any = Record<string, FC<any>>;
export const { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } = AD as unknown as Any;
export const { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } = DG as unknown as Any;
export const { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } = DM as unknown as Any;
